import {
    Box,
    Container,
    Grid,
    Heading,
    useMediaQuery,
    VStack
} from '@chakra-ui/react';
import Footer from '../Footer';
import { useMeQuery } from '../generated/graphql';
import NavBar from '../student/NavBar';
import ExperienceCard from './ExperienceCard';
import ExtracurricularCard from './ExtracurricularCard';
import Header from './Header';
import HeaderAvatar from './HeaderAvatar';
import Info from './Info';
import './Profile.scss';
import Skills from './Skills';
import Video from './Video';

const data = {
    headerImage: '/temp_bg.png',
    user: {
        avatarImage: '/temp-user-ava.png',
        name: 'Jenny Nguyen',
        studies: 'Sophomore at UCLA double majoring in Cognitive Science and Statistics',
        seeking: 'seeking investment banking internship opportunities',
        education: 'University of California, Los Angeles',
        major: 'Cognitive Science, Statistics',
        gpa: '4.0',
        graduationDate: 'Class of 2024',
        lookingForRoles: 'Remote'
    }
};

export enum ViewType {
    Admin,
    Student,
    LoggedOut
}

function Profile({ view }: { view: ViewType }) {
    const [isMobile] = useMediaQuery('(max-width: 480px)');

    const { data: userData, loading: isLoading } = useMeQuery({
        variables: {}
    });

    if (!userData && !isLoading) {
        return <div>User not found</div>;
    }

    const profile = userData?.me?.profile;
    const user = userData?.me;
    const videoLink = userData?.me?.profile?.elevator_pitch_url;

    const allExperiences = profile?.experience?.map((experience) => (
        <ExperienceCard
            startDate={experience?.start_date!}
            endDate={experience?.end_date!}
            employer={experience?.employer!}
            description={experience?.description!}
            profileId={profile?.id!}
            title={experience?.title!}
            isCurrent={experience?.is_current!}
            isLoaded={!isLoading}
        />
    ));

    const allActivities = profile?.activity?.map((activity) => (
        <>
            <hr />
            <ExtracurricularCard
                startDate={activity?.start_date!}
                endDate={activity?.end_date!}
                title={activity?.title!}
                name={activity?.name!}
            />
        </>
    ));

    return (
        <>
            {view === ViewType.Student ? <NavBar /> : null}
            <Header headerImage={data.headerImage} />
            <Container maxW="container.xl" p={{ base: '0', lg: '0 3rem' }}>
                <Grid templateColumns={{ base: '1fr', lg: '31% 69%' }} gap={6}>
                    <VStack align="stretch">
                        <HeaderAvatar
                            view={view}
                            loading={isLoading}
                            name={user?.first_name + ' ' + user?.last_name}
                            firstName={user?.first_name}
                            lastName={user?.last_name}
                            slug={profile?.slug}
                            email={user?.email}
                            photoURL={''}
                            portfolioLink={profile?.portfolio_link}
                            oneLinkDescription={profile?.small_description}
                            resumeLink={profile?.resume}
                        />

                        {/* On Mobile, move Elevator Pitch to top of page */}
                        {isMobile && videoLink ? (
                            <Video
                                pid={profile?.id ?? ''}
                                videoUrlSet={profile?.elevator_pitch_url === ''}
                                videoUrl={profile?.elevator_pitch_url}
                                loading={isLoading}
                            />
                        ) : null}

                        <Info
                            loading={isLoading}
                            education={user?.education}
                            locations={profile?.locations}
                        />
                        {isMobile ? allExperiences : null}
                        {isMobile && allActivities ? allActivities : null}
                        <Skills
                            tools={profile?.tools!}
                            strengths={profile?.strengths!}
                            loading={isLoading}
                            profileId={profile?.id!}
                        />
                    </VStack>

                    {!isMobile ? (
                        <VStack align="stretch">
                            {videoLink && <Video
                                pid={profile?.id ?? ''}
                                videoUrlSet={profile?.elevator_pitch_url === ''}
                                videoUrl={profile?.elevator_pitch_url}
                                loading={isLoading}
                            />}
                            {allExperiences && allExperiences?.length > 0 ? <Box marginTop="7px">
                                <Heading size="md" mb="2">
                                    Experience 💼
                                </Heading>
                                {allExperiences}
                            </Box>:''}

                            {allActivities && allActivities?.length > 0 ? <Box w="full">
                                <Heading size="md" mb="2" pl="25px">
                                    Extracurriculars ✨
                                </Heading>
                                <Box
                                    border="1px solid #EEEDF2"
                                    borderRadius={{ lg: 'xl' }}
                                    pr="6"
                                    pl="6"
                                    backgroundColor="#FFFFFF"
                                    maxW="744px"
                                    mb="6"
                                >
                                    {allActivities}
                                </Box>
                            </Box> : ''}
                        </VStack>
                    ) : null}
                </Grid>
            </Container>
            <Footer />
        </>
    );
}

export default Profile;
